(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["football-division-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const dropdown = event.target.closest('.football-divisions__dropdown');
    if (!dropdown || !dropdown.open) return;
    dropdown.open = false;
    dropdown.querySelector('summary').focus();
  });
  } catch(e) { console.error(e); }
})();

})();
